import Footer from "./Component/Footer";
import Header from "./Component/Header";
import Contact from "./Component/Contact";
import Spender from "./Component/Spender";
import Profile from "./Component/Profile";
import Banner from "./Component/Banner";

export default function Home({ dailySales = [] }) {
   
    return <>
        <Header />

        <main id="content">

            <Banner />
            <Spender members={dailySales} />
            {/* <Profile /> */}
            <Contact />
        </main>
        <Footer />
    </>
}
